import {TakipAcStatusEnum} from "./parser/TakipAcStatusEnum";
import app from "@/main";
import {MtsXmlParser} from "./MtsXmlParser";
import TakipAcInjectable from "./TakipAcInjectable";
import {Mixins} from "./Mixins";
import {MtsTakipTalebiOlusturCevap, MtsTakipTalebiOlusturTalep} from "../uyap/MtsTakipTalebiOlustur";
import {MtsDavaAcilisTalep} from "../uyap/MtsDavaAcilis";
import {saveAs} from "file-saver";
import {TamamlanmayanDosyalarRow, TamamlanmayanDosyaTurKod} from "../uyap/TamamlanmayanDosyalar";
import {matchUyapError} from "../uyap/uyapErrorMatchers";
import Args from "@/plugins/uyap-plugin/takip_ac/parser/Args";
import {OdemeTipiEnum} from "@/plugins/uyap-plugin/takip_ac/OdemeTipleri";
import {DosyaEvraklarCevap, IDosyaEvrak} from "@/plugins/uyap-plugin/uyap/DosyaEvraklar";
import {IAvukatDosya, UyapTarih} from "@/plugins/uyap-plugin/uyap/CommonInterfaces";
import {AvukatIcraDosyalariTalep} from "@/plugins/uyap-plugin/uyap/AvukatIcraDosyalari";
import {odemeZamanAsimiMesaji} from "@/plugins/uyap-plugin/takip_ac/AcilmisTakipHatasi";
import {durdurucuHataMi} from "../utils/tebligatTalepUtils";

export default class MtsTakipAc extends TakipAcInjectable {
    parsedFile!: MtsXmlParser;
    tevziBilgileri !: MtsTakipTalebiOlusturCevap;
    tempId: number = 0;
    toplamTakibeEsasMiktar: number = 1;
    mtsHarcBilgileri = {
        selectedTarafHashKeyList: ["kurum_0"],
        selectedTarafHashList: []
    }
    dosyaBilgileri!: TamamlanmayanDosyalarRow;
    evraklar!: DosyaEvraklarCevap;
    eslesenUyapDosyalar: Array<{ dosyaNo: string; birimAdi: string; acilisTarihi: string }> = [];
    eslesenUyapSecimOnayZamani: string | null = null;

    static fromJson(jsonData: any): MtsTakipAc {
        let mtsTakipAc =  Args.staticFromJson(jsonData,new MtsTakipAc());
        mtsTakipAc.parsedFile = MtsXmlParser.fromJson(jsonData.parsedFile);
        return mtsTakipAc;
    }

    //Yetkili Kurum secmesi gerekiyor.

    async runQuery(): Promise<void> {
        try {
            this.setStatus(TakipAcStatusEnum.QUERY_PENDING);
            console.log("MTS parsedFile", this.parsedFile);
            for (const taraf of this.parsedFile.tarafList) {
                try {
                    await taraf.runQuery(this.parsedFile.formData.alacakliTaraf);
                } catch (e) {
                    // DEV-3879: Durdurma/oturum hatasında harç isteğine geçilmez.
                    if (durdurucuHataMi(e))
                        throw e;
                    this.setStatus(TakipAcStatusEnum.QUERY_FAIL);
                    console.error("tarafList HATA", e);
                }
            }
            await this.runQueryForHarcList();
            this.setStatus(TakipAcStatusEnum.QUERY_SUCCESS);
            return Promise.resolve();
        } catch (e) {
            this.setStatus(TakipAcStatusEnum.QUERY_FAIL);
            console.error("ERR RUNQUERY", e, this);
            return Promise.reject(e);
        }
    }

    // DEV-3879: Adresi olmayan şirket UYAP'a "adresList: [null]" ile gidince UYAP yalnızca
    // "Taraf adres bilgisi (GENEL) alınamadı." diyor; istek atmadan hangi şirket olduğunu söyle.
    adresiOlmayanKurumKontrol(): void {
        for (const taraf of this.parsedFile.tarafList) {
            if (!taraf.isKurum())
                continue;
            const adres = taraf.adresBilgisi;
            const adresVar = !!adres && (String(adres.adres || "").trim() != "" || String(adres.eTebligatAdresi || "").trim() != "");
            if (!adresVar) {
                const rol = taraf.isBorclu() ? "Borçlu" : "Alacaklı";
                const kurumAdi = String(taraf.temelBilgileri?.kurumAdi || taraf.kurumAdi || "").trim();
                throw new Error(rol + " şirket için adres bulunamadı: " + kurumAdi + " (UYAP adres listesinde ve XML'de kullanılabilir adres yok).");
            }
        }
    }

    async runQueryForHarcList(): Promise<any> {
        try {
            this.adresiOlmayanKurumKontrol();
            let harcBilgileri = await app.$uyap.MtsHarcList().run(this.toUyapJson());
            this.parsedFile.harcMasrafToplam = harcBilgileri.toplam;
            // @ts-ignore
            this.mtsHarcBilgileri.selectedTarafHashList = harcBilgileri.data;
            return Promise.resolve();
        } catch (e) {
            return Promise.reject(e);
        }
    }

    async checkDuplicateTakip(): Promise<void> {
        if (!this.parsedFile?.tarafList) return;

        const borclular = this.parsedFile.tarafList.filter(t => t.isBorclu());
        if (borclular.length === 0) return;

        const birHaftaOnce = new Date();
        birHaftaOnce.setDate(birHaftaOnce.getDate() - 7);
        birHaftaOnce.setHours(0, 0, 0, 0);

        const eslesenler: Array<{ dosyaNo: string; birimAdi: string; acilisTarihi: string }> = [];

        for (const borclu of borclular) {
            try {
                const talep = new AvukatIcraDosyalariTalep();

                if (borclu.kisiMi) {
                    const tcKimlikNo = borclu.temelBilgileri?.tcKimlikNo?.toString().trim() || '';
                    const adi = borclu.temelBilgileri?.adi || '';
                    const soyadi = borclu.temelBilgileri?.soyadi || '';
                    if (tcKimlikNo && Mixins.checkTcNum(tcKimlikNo)) {
                        talep.setKisi('', '', tcKimlikNo);
                    } else {
                        talep.setKisi(adi, soyadi, '');
                    }
                } else if (borclu.kurumMu) {
                    const kurumAdi = borclu.kurumAdi || borclu.temelBilgileri?.kurumAdi || '';
                    const mersisNo = borclu.mersisNo || borclu.temelBilgileri?.mersisNo || '';
                    const vergiNo = borclu.vergiNo || borclu.temelBilgileri?.vergiNo || '';
                    if (vergiNo)
                        talep.setKurum('', '', vergiNo);
                    else if (mersisNo)
                        talep.setKurum('', mersisNo, '');
                    else
                        talep.setKurum(kurumAdi, '', '');
                } else {
                    continue;
                }

                const sonuc = await app.$uyap.AvukatIcraDosyalari().run(talep);
                if (!sonuc?.items?.length) continue;

                const sonBirHaftaDosyalar = sonuc.items.filter((dosya: IAvukatDosya) => {
                    if (!dosya.dosyaAcilisTarihi) return false;
                    const acilisTarihi = this.uyapTarihToDate(dosya.dosyaAcilisTarihi);
                    return acilisTarihi >= birHaftaOnce;
                });

                for (const dosya of sonBirHaftaDosyalar) {
                    const zatenVar = eslesenler.some(e => e.dosyaNo === dosya.dosyaNo && e.birimAdi === dosya.birimAdi);
                    if (!zatenVar) {
                        eslesenler.push({
                            dosyaNo: dosya.dosyaNo,
                            birimAdi: dosya.birimAdi,
                            acilisTarihi: this.formatUyapTarih(dosya.dosyaAcilisTarihi)
                        });
                    }
                }
            } catch (e) {
                console.error('Mükerrer takip kontrolü sırasında hata:', e);
            }
        }

        if (eslesenler.length > 0) {
            this.eslesenUyapDosyalar = eslesenler;
            this.setStatus(TakipAcStatusEnum.DUPLICATE_WARNING);
            const dosyaListesi = eslesenler.map(d => `${d.dosyaNo} - ${d.birimAdi} (${d.acilisTarihi})`).join(', ');
            this.addMessage("info", `UYAP'ta eşleşen takip bulundu: ${dosyaListesi}`);
        }
    }

    private uyapTarihToDate(uyapTarih: UyapTarih): Date {
        return new Date(uyapTarih.date.year, uyapTarih.date.month - 1, uyapTarih.date.day);
    }

    private formatUyapTarih(uyapTarih: UyapTarih): string {
        const g = String(uyapTarih.date.day).padStart(2, '0');
        const a = String(uyapTarih.date.month).padStart(2, '0');
        return `${g}.${a}.${uyapTarih.date.year}`;
    }

    formatTarihUyap(d: Date): string {
        return `${String(d.getDate()).padStart(2, '0')}.${String(d.getMonth() + 1).padStart(2, '0')}.${d.getFullYear()}`;
    }

    async tevziAl(): Promise<any> {
        try {
            this.setStatus(TakipAcStatusEnum.PREPARE_PROCESSING);
            await this.mukerrerDosyaKontrol(this.parsedFile.hash, "xml");
            this.addMessage('info', 'Tevzi alınıyor!')

            const tamamlanmayanDosyaSayisi = (await app.$uyap.TamamlanmayanDosyalar().run({
                dosyaTurKod: TamamlanmayanDosyaTurKod.MTS,
                baslangicTarihi: this.formatTarihUyap(new Date()),
                bitisTarihi: this.formatTarihUyap(new Date())
            })).length;
            try {
                this.tevziBilgileri = await app.$uyap.MtsTakipTalebiOlustur().run(this.tevziToUyapJson());
            } catch (e) {
                // Bilinen bir UYAP yönlendirme hatası (ör. tamamlanmayan dosya) kesin bir
                // reddir; sayaç-diff mantığının bunu "tevzi oluştu" sanıp yutmaması için fırlat.
                if (matchUyapError(e)) throw e;
                const tevziSonrasiTamamlanmayanDosyaSayisi = (await app.$uyap.TamamlanmayanDosyalar().run({
                    dosyaTurKod: TamamlanmayanDosyaTurKod.MTS,
                    baslangicTarihi: this.formatTarihUyap(new Date()),
                    bitisTarihi: this.formatTarihUyap(new Date())
                })).length;
                if (tamamlanmayanDosyaSayisi == tevziSonrasiTamamlanmayanDosyaSayisi)
                    throw e;
            }
            this.addMessage('info', 'Tevzi alındı.!');
            this.addMessage('success', 'Tevzi alma işlemi başarılı!');
            this.setStatus(TakipAcStatusEnum.PREPARE_SUCCESS);
            await this.tevziAlinmisDosyaKaydet();
            try{
                this.addMessage('info', 'Takip talebi hazırlanıyor!');
                await this.mtsGetImzasizUdfFromUyap(this.tevziBilgileri.dosyaId);
            }catch (e) {
                console.error("TAKIP TALEBI INDIRILEMEDI. error: ", e);
            }
            return Promise.resolve();
        } catch (e) {
            this.setStatus(TakipAcStatusEnum.PREPARE_FAILED);
            // UYAP hata yönlendirmeleri (adres limiti, tamamlanmayan dosya, vb.) tek merkezden.
            const yonlendirme = matchUyapError(e);
            if (yonlendirme) {
                this.addMessage('error', yonlendirme.userMessage);
                // errorCode'u koru ki üst catch (takipBaslatYeni) mesajı tanıyıp önek eklemesin.
                return Promise.reject(e);
            }
            this.addMessage('error', 'Tevzi alma işleminde hata oluştu!' + e.message);
            return Promise.reject(e);
        }
    }

    async tevziAlinmisDosyaKaydet(): Promise<any> {
        ///v1/uyap-takip
        let uyap_id =
            this.tevziBilgileri.birimID +
            "/" +
            this.convertToISOFormat(this.tevziBilgileri.dosyaAcilisTarihi);

        // Hemen aç base64 data temizleme
        const parsedForApi = JSON.parse(
            JSON.stringify(this.parsedFile, (key, val) =>
                key === "dosyaNode" ? null : val
            )
        ) as Record<string, unknown>;
        const v = parsedForApi.vekalet;
        if (v && typeof v === "object") {
            delete (v as Record<string, unknown>).data;
        }
        const dayanakList = parsedForApi.dayanaklar;
        if (Array.isArray(dayanakList)) {
            parsedForApi.dayanaklar = dayanakList.map((d: unknown) => {
                if (d && typeof d === "object") {
                    const copy = { ...(d as Record<string, unknown>) };
                    delete copy.data;
                    return copy;
                }
                return d;
            });
        }
        const objList = parsedForApi.dayanaklarObject;
        const dayanakForApi =
            Array.isArray(objList) && objList.length > 0
                ? objList
                : (parsedForApi.dayanaklar as unknown[]) || [];

        const dosyaForApi = JSON.parse(
            JSON.stringify(this, (key, val) =>
                key === "parsedFile" ? parsedForApi : val
            )
        );

        return await app.$http.post("/api/v1/uyap-takip/", {
            hash: this.parsedFile.hash,
            type: "xml",
            dosya: dosyaForApi,
            uyap_dosya_id: this.tevziBilgileri.dosyaId,
            uyap_id: uyap_id,
            uyap_id_hash: btoa(uyap_id),
            // uyap_takip.vekalet_id File id'sidir; OfisPro kaydında id Vekalet id'si, File id file_id'de.
            vekalet_id: (this.parsedFile.vekaletObject as any)?.file_id ?? this.parsedFile.vekaletObject?.id,
            dayanak: dayanakForApi,
            status: 1,
        });
    }

    async takipTalebiIndir() {
        saveAs(this.imzasizUdf, "takiptalebi.udf");

    }

    async hemenTakipAc(): Promise<void>{
        await this.runQuery();
        await this.tevziAl();
        await this.takipBaslat(false);
    }

    async takipBaslat(isTamamlanmayanDosya = true): Promise<void> {
        this.eksikBitisBayraklariniSifirla();
        try {

            this.setStatus(TakipAcStatusEnum.OPEN_PROCESSING);
            await this.vekaletKontrol();
            await this.dayanakKontrol();
            if(isTamamlanmayanDosya){
                let uyapDosya = await app.$uyap.TamamlanmayanDosyaBul().run({
                    birimId: this.tevziBilgileri.birimID,
                    acilisTime: new Date(this.tevziBilgileri.dosyaAcilisTarihi).getTime(),
                    dosyaAcilisTarihi: this.tevziBilgileri.dosyaAcilisTarihi
                },true);
                //let dosyaId = uyapDosya.dosyaID;
                this.tevziBilgileri.dosyaId = uyapDosya.dosyaID;
            }

            await this.mtsGetImzasizUdfFromUyap(this.tevziBilgileri.dosyaId);
            await this.takipAcilisEvraklariniGonder(this.tevziBilgileri.dosyaId,true);

            if (this.toplamTakibeEsasMiktar == 0 && this.parsedFile.formData.odemeYapilmasin === true) {
                //harc muafli takip acilmissa odeme yapmiyor...
                await this.setTakipBilgileriFromTakipAcilisEvraklariResponse();
                await this.tevziAlinmisDosyayiAcigaCek();
            } else if (this.toplamTakibeEsasMiktar == 0) {
                //harc muafli takip acilmissa odeme yapmiyor...
                await this.setTakipBilgileriFromTakipAcilisEvraklariResponse();
                await this.tevziAlinmisDosyayiAcigaCek();
            } else if (this.parsedFile.formData.odemeYapilmasin === true) {
                this.takipBilgileri.dosyaEsasNo = "Dosya tevzi alındı. " + this.takipAcilisEvraklariResponse.message;
                this.takipBilgileri.icraDairesi = "Merkezi Takip Sistemi";
                this.addMessage("success", "Takibiniz ödeme yapılmasın seçilerek açılmıştır. Ödemenizi UYAP üzerinden yapabilirsiniz.");
                this.setStatus(TakipAcStatusEnum.OPEN_SUCCESS);
            } else {
                await this.odemeYap();
                await this.tevziAlinmisDosyayiAcigaCek();
            }
            // await şart: senkron hatası fonksiyon içinde uyarıya çevriliyor.
            await this.setTakipBilgileriToIcraPro(this.parsedFile.mtsDosyaBilgileri, this.tevziBilgileri.birimID);
            return;
        } catch (e) {
            // DEV-3302: hata yutulmaz, takipBaslatYeni gibi fırlatılır. Yutulunca handler görevi
            // BITTI_BASARILI yapıyor, açılmamış takip yeşil tikle görünüyordu.
            if (/zaman aşımı/i.test(e.message || '')) {
                this.setStatus(TakipAcStatusEnum.OPEN_FAIL);
                throw new Error(e.message);
            }
            // UYAP hata yönlendirmesi (ör. evrak gönderme aksaklığı) varsa ham metin yerine yönlendirici mesaj göster.
            const yonlendirme = matchUyapError(e);
            if (yonlendirme) {
                this.addMessage('error', yonlendirme.userMessage);
                this.setStatus(TakipAcStatusEnum.OPEN_FAIL);
                throw new Error(yonlendirme.userMessage);
            }
            this.addMessage('error', 'HATA - ' + e.message);
            this.setStatus(TakipAcStatusEnum.OPEN_FAIL);
            throw new Error(e.message);
        }
    }

    async takipBaslatYeni(isHemenAc: boolean = false, odemeYapilsin: boolean = false): Promise<void> {
        this.eksikBitisBayraklariniSifirla();
        try {
            this.setStatus(TakipAcStatusEnum.OPEN_PROCESSING);

            await this.tevziAl();

            await this.vekaletKontrol(isHemenAc);
            await this.dayanakKontrol(isHemenAc);

            if (!isHemenAc)
                await this.mtsGetImzasizUdfFromUyap(this.tevziBilgileri.dosyaId);

            // TODO: SORULACAK: toplamTakibeEsasMiktar sıfır ise otomatik açar ödeme yapılmasın ise göndermesin
            await this.takipAcilisEvraklariniGonder(this.tevziBilgileri.dosyaId, true);

            if (this.toplamTakibeEsasMiktar == 0) {
                //harc muafli takip acilmissa odeme yapmiyor...
                await this.setTakipBilgileriFromTakipAcilisEvraklariResponse();
                await this.tevziAlinmisDosyayiAcigaCek();
            } else if (!odemeYapilsin) {
                this.takipBilgileri.dosyaEsasNo = "Dosya tevzi alındı. " + this.takipAcilisEvraklariResponse.message;
                this.takipBilgileri.icraDairesi = "Merkezi Takip Sistemi";
                this.addMessage("success", "Takibiniz ödeme yapılmasın seçilerek açılmıştır. Ödemenizi UYAP üzerinden yapabilirsiniz.");
                this.setStatus(TakipAcStatusEnum.OPEN_SUCCESS);
            } else {
                await this.odemeYap();
                await this.tevziAlinmisDosyayiAcigaCek();
            }
            // await şart: senkron hatası fonksiyon içinde uyarıya çevriliyor.
            await this.setTakipBilgileriToIcraPro(this.parsedFile.mtsDosyaBilgileri, this.tevziBilgileri.birimID);
            return;
        } catch (e) {
            if (/zaman aşımı/i.test(e.message || '')) {
                this.setStatus(TakipAcStatusEnum.OPEN_FAIL);
                throw new Error(e.message);
            }
            // UYAP hata yönlendirmesi (ör. evrak gönderme aksaklığı) varsa ham metin yerine yönlendirici mesaj göster.
            const yonlendirme = matchUyapError(e);
            if (yonlendirme) {
                this.addMessage('error', yonlendirme.userMessage);
                this.setStatus(TakipAcStatusEnum.OPEN_FAIL);
                throw new Error(yonlendirme.userMessage);
            }
            this.addMessage('error', 'HATA - ' + e.message);
            this.setStatus(TakipAcStatusEnum.OPEN_FAIL);
            throw new Error(e.message);
        }
    }

    /** Hata fırlatmaz; güncellenemezse görev BITTI_EKSIK biter (bkz. hashKaydiniAcildiYap). */
    async tevziAlinmisDosyayiAcigaCek(): Promise<void> {
        await this.hashKaydiniAcildiYap(this.parsedFile.hash);
    }

    async odemeYap(): Promise<void> {
        try {

            //https://avukatbeta.uyap.gov.tr/mtHarcListDosyaid_brd.ajx POST params dosyaId json olarak
            //[{"harcmasrafKodStr":144205,"harcmasrafBedelmiOranmi":"O","harcMasrafOran":2,"hesapMiktar":6291.35,"ekranID":9,"pesinHarcDusulsunmu":"H","harcMasrafAltSiniri":615.4,"hmDurumu":0,"hmAktif":false,"isSatirDegisecek":false,"harcMasrafKod":63266,"harcMasrafAdi":"MTS Harcı","aciklama":"Mts Harcı","baslangicHarci":"E","harcMasraf":"H","harcTip":34,"gv_tabi":0,"dv_tabi":0,"yg_tabi":0,"makbuzTipi":1},{"harcmasrafKodStr":144200,"harcmasrafBedelmiOranmi":"B","harcMasrafBedel":87.5,"hesapMiktar":87.5,"ekranID":9,"pesinHarcDusulsunmu":"H","hmDurumu":0,"hmAktif":false,"isSatirDegisecek":false,"harcMasrafKod":12809,"harcMasrafAdi":"Vekalet Suret Harcı","aciklama":"Vekaletname Suret Harcıdır","baslangicHarci":"E","harcMasraf":"H","harcTip":14,"gv_tabi":0,"dv_tabi":0,"yg_tabi":0,"makbuzTipi":1}]
            //https://avukatbeta.uyap.gov.tr/vekaletPuluBedeli.ajx POST json return düz 138

            await app.$uyap.MtsHarcListDosyaId().run({dosyaId: this.tevziBilgileri.dosyaId});
            await app.$uyap.VekaletPuluBedeli().run({});
            // İstek gönderilmeden önce işaretle: cevap alınamadan çökersek yeniden
            // başlatmada bu durum görülüp kullanıcıdan UYAP kontrolü istenir.
            await this.odemeDeneniyorIsaretle(this.parsedFile.hash);
            let takipBilgileri = await app.$uyap.MtsDavaAcilis().run({dosyaId: this.tevziBilgileri.dosyaId,odemeTipi:OdemeTipiEnum.Ebarobirlikkart});
            this.takipBilgileri.dosyaEsasNo = takipBilgileri.dosyaNo;
            this.takipBilgileri.icraDairesi = takipBilgileri.birimAdi;
            this.addMessage('success', 'Takip açıldı.');
            this.setStatus(TakipAcStatusEnum.OPEN_SUCCESS);
        } catch (e) {
            const isTimeout = /timeout/i.test(e.message || '');
            if (isTimeout) {
                // Sonuç bilinmiyor: kayıt odeme_deneniyor durumunda bırakılır.
                const timeoutMsg = odemeZamanAsimiMesaji();
                this.addMessage("warning", timeoutMsg);
                this.setStatus(TakipAcStatusEnum.OPEN_FAIL);
                throw new Error(timeoutMsg);
            }
            await this.odemeDeneniyorGeriAl(this.parsedFile.hash);
            this.addMessage('error', 'Ödeme hatası - ' + e.message);
            // errorCode'u koru ki üst catch (takipBaslatYeni) matchUyapError ile yönlendirici mesaj gösterebilsin.
            throw e;
        }
    }

    async vekaletKontrol(isHemenTakipBaslat: boolean = false): Promise<void> {
        try {
            const vekalet: any = this.parsedFile.vekalet;
            // Hemen Aç önceki denemeden kalan dosyayı kullanmaz; kuyrukta JSON'dan gelen {} dosya sayılmaz.
            if (!isHemenTakipBaslat && this.vekalet instanceof Blob && this.vekalet.size > 0) return;
            // XML/elle yüklenen vekalet: içeriği varsa her modda ondan üretilir.
            if (vekalet?.data) {
                // @ts-ignore
                const vekaletBlob = Mixins.b64toBlob(vekalet.data, vekalet.mimeType);
                this.vekalet = new File([vekaletBlob], vekalet.name, {type: vekalet.mimeType,});
                return ;
            }
            // OfisPro'dan seçilen vekalet içeriksiz kayıttır, indirilir. DEV-4188 öncesi görevlerde kayıt vekalet'te kaldı.
            const vo: any = this.parsedFile.vekaletObject || (vekalet?.file_path ? vekalet : null);
            if (!vo) {
                let message = "Vekalet eklenmemiş lütfen vekalet ekleyiniz!";
                this.addMessage("error", message);
                throw  new Error(message);
            }
            const blob = await app.$uyapHelper.getBlobFromLink(
                "/api/v1/file/download/" + vo.file_path.replace("uploads/", "")
            );
            // Backend CDN hatasında 200 + JSON döner; PDF diye UYAP'a gitmesin.
            if (blob.type === "application/json") {
                throw new Error("Vekalet dosyası indirilemedi, OfisPro'daki vekalet dosyasını kontrol ediniz.");
            }
            this.vekalet = new File([blob], vo.name, {
                type: vo.mime_type || "application/octet-stream",
            });
        } catch (e) {
            this.addMessage("error", e.message);
            throw new Error(e);
        }
    }

    async dayanakKontrol(isHemenTakipBaslat: boolean = false): Promise<void> {
        try{
            if (isHemenTakipBaslat) {
                for (const dayanak of this.parsedFile.dayanaklar) {
                    // @ts-ignore
                    const dayanakBlob = Mixins.b64toBlob(dayanak.data, dayanak.mimeType);
                    this.dayanaklar.push(
                        new File([dayanakBlob], dayanak.name, { type: dayanak.mimeType })
                    );
                }
                return;
            }
            for (const dayanak of this.parsedFile.dayanaklarObject) {
                const blob = await app.$uyapHelper.getBlobFromLink(
                    "/api/v1/file/download/" + dayanak.file_path.replace("uploads/", "")
                );
                this.dayanaklar.push(
                    new File([blob], dayanak.name, {
                        type: dayanak.mime_type || "application/octet-stream",
                    })
                );
            }
        }catch (e) {
            throw new Error("Dayanaklar yüklenemedi !. " + e.message);
        }
    }

    davaAcilisToUyapJson(): MtsDavaAcilisTalep {
        let data: any = this.tevziToUyapJson();
        data.dosyaId = this.tevziBilgileri.dosyaId;
        return data;
    }

    tevziToUyapJson(): MtsTakipTalebiOlusturTalep {
        let {
            dosyaAciklama_48_4,
            mahiyetList,
            dosyaKriterList,
            terekemi,
            selectedIl,
            selectedBirim
        }: any = this.parsedFile.mtsDosyaBilgileri;
        let tarafList = this.toUyapTarafList();
        terekemi = Mixins.booleanToXmlStrings(terekemi);

        return {
            MTS: 1,
            MTSDosyaBilgileri: JSON.stringify({
                dosyaAciklama_48_4,
                mahiyetList,
                dosyaKriterList,
                terekemi,
                selectedIl,
                selectedBirim,
            }),
            tarafList: JSON.stringify(tarafList),
            ilamsizList: JSON.stringify(this.parsedFile.ilamsizList.map((i) => i.toUyapJson())),
            MTSHarcBilgileri: JSON.stringify(this.mtsHarcBilgileri)
        }
    }

    toUyapTarafList() {
        //let tarafList = this.tarafList.map((i) => i.toUyapJson());
        let kisiList = this.parsedFile.tarafList.filter(taraf => taraf.isKisi() === true);
        let kurumList = this.parsedFile.tarafList.filter(taraf => taraf.isKurum() === true);
        return {
            kisiList: kisiList.map((taraf, key) => taraf.toUyapJson(key)),
            kurumList: kurumList.map((taraf, key) => taraf.toUyapJson(key))
        };
    }

    toUyapJson() {
        let result = {
            ilamsizList: JSON.stringify(this.parsedFile.ilamsizList.map((i) => i.toUyapJson())),
            tarafList: JSON.stringify(this.toUyapTarafList())
        };
        console.log("MTS toUyapJson", result);
        return result;
    }

    toUyapJsonTest() {
        return {
            ilamsizList: this.parsedFile.ilamsizList.map((i) => i.toUyapJson()),
            tarafList: this.toUyapTarafList()
        };
    }

    async getTahsilHarciMakbuzuBlob(): Promise<Blob> {
        return await this.getEvrakBlobFromType(
            "Tahsil Harcı Makbuzu(Sayman Mutemet Alındısı)"
        );
    }

    async getTahsilatMakbuzuBlob(): Promise<Blob> {
        return await this.getEvrakBlobFromType("Tahsilat makbuzu");
    }

    async getDosyaEvraklar() {
        if (!this.evraklar)
            this.evraklar = await app.$uyap.DosyaEvraklar().run({dosyaId: this.tevziBilgileri.dosyaId});
    }

    async getEvrakBlobFromType(type: string): Promise<Blob> {
        await this.getDosyaEvraklar();

        const tumEvraklarList = Object.values(this.evraklar?.tumEvraklar || {}).reduce(
            (acc: IDosyaEvrak[], list) => acc.concat(list),
            []
        );

        const evrak = tumEvraklarList.find((item: IDosyaEvrak) => item.tur && item.tur.includes(type));

        if (evrak) {
            let dosyaId = evrak.dosyaId || this.tevziBilgileri?.dosyaId;
            let evrakId = evrak.evrakId || evrak.ggEvrakId;

            if (!dosyaId || !evrakId) {
                throw new Error("Evrak bilgileri eksik.");
            }

            return await app.$uyap.EvrakIndir().run({
                dosyaId: String(dosyaId),
                evrakId: String(evrakId),
                yargiTuru: "",
            });
        } else {
            throw new Error(`${type} evrağı bulunamadı.`);
        }
    }
}